import React from 'react'

import { Container, Content } from './styles'

import IProps from './props'

const PrimaryHeader = ({ children, style }: IProps) => (
  <Container
    style={style}
  >
    <Content>{children}</Content>
  </Container>
)

export default PrimaryHeader
